import notification from '@/assets/svg/notification.svg'

export default {
  props: {
    details: {
      type: Object
    },
    defaultType: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modal: true,
      notificationIcon: notification
    }
  },
  methods: {
    closeModal() {
      this.modal = false
      this.$emit('close')
    },
    confirmCancel() {
      this.modal = false
      this.$emit('confirmed')
      this.$emit('close')
    }
  }
}
